// extracted by mini-css-extract-plugin
export default {"infoBoxContainer":"_2mn8BMESu9CWu28wfU9VZy"};